// appIconMapping.ts

import { environment } from "../../../../environments/environment";

const BASE_URL = environment.CMSURL_IMG;

export const APP_ICONS: Record<string, string> = {
  "Sales": `${BASE_URL}/wp-content/uploads/2024/08/sales-icon.png`,
  "Q&P": `${BASE_URL}/wp-content/uploads/2024/08/qp-icon.png`,
  "Procurement": `${BASE_URL}/wp-content/uploads/2024/08/procurement-icon.png`,
  "ORG": `${BASE_URL}/wp-content/uploads/2024/08/organization-icon.png`,
  "Innovation": `${BASE_URL}/wp-content/uploads/2024/08/innovation-icon.png`,
  "IT": `${BASE_URL}/wp-content/uploads/2024/08/it-icon.png`,
  "Finance": `${BASE_URL}/wp-content/uploads/2024/08/finance-icon.png`,
  "Corporate": `${BASE_URL}/wp-content/uploads/2024/08/corporate-icon.png`,
  "HR": `${BASE_URL}/wp-content/uploads/2024/08/hr-icon.png`,
  "Marketing": `${BASE_URL}/wp-content/uploads/2024/08/marketing-icon.png`,
  "Admin": `${BASE_URL}/wp-content/uploads/2024/08/admin-icon.png`,
  "Global Engineering Academy": `${BASE_URL}/wp-content/uploads/2024/08/training-icon.png`,
  "Training and Learning": `${BASE_URL}/wp-content/uploads/2024/08/training-icon.png`
};
 
